module.exports = __webpack_public_path__ + "img/video.3b2b0a8.svg";